module.exports = __webpack_public_path__ + "img/lg.e7a55f17.png";